import React, { useEffect } from 'react';
import Breadcrumb from '../components/ShearedComponents/Breadcrumb';
import Card from '../components/Product/Card';
import Gallery from '../components/Product/gallery/Gallery';
import Relaated from '../components/Product/related/Relaated';
import { useGetProductQuery } from '../features/api/apiSlice';
import ErrorAlert from '../components/ui/ErrorAlert';
import { useParams } from 'react-router-dom';
import ProdactDetailLoader from '../components/ui/loaders/ProdactDetailLoader';
import { useTranslation } from 'react-i18next';

const Product = () => {
    const { productId } = useParams();
    const { data: product, isLoading, isError } = useGetProductQuery(productId);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const { t } = useTranslation();

    let content = null;

    if (isLoading) {
        content = (
            <div>
                <ProdactDetailLoader/>
            </div>
        )
    }
    if (!isLoading && isError) {
        content = (
            <div className='my-5 py-3 mx-3 px-3 bg-slate-200'>
                <h2 className="text-xl">{t('utils.error')}</h2>
            </div>
        )
    }
    if (!isLoading && !isError && product === null) {
        content = (
            <div className='bg-gray-300 p-3 mt-5 mb-2 mx-3'>
                <h1 className="">{t('utils.notFound')}</h1>
            </div>
        )
    }
    if (!isLoading && !isError && product?._id) {
        content = (
            <div className='container mx-auto'>
                <Breadcrumb page="Product Details" name={product.name} />
                <div className='over overflow-hidden'>
                    <div className='main md:py-5 grid justify-center content-center md:grid-cols-5 grid-cols-1 gap-5'>
                        <div className='md:col-span-2 md:px-4'>
                            <Gallery galleryImages={product.galleryImages} />
                        </div>
                        <div className='md:col-span-3 md:px-4'>
                            <Card product={product} />
                        </div>
                    </div>
                </div>
                <div>
                    <Relaated productCategory={product.category} />
                </div>
            </div>
        )
    }

    return content;
};

export default Product;